export default __webpack_public_path__ + "static/media/OGSeacreature.e4470ad3.webp";